import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { WhatsAppButton } from "./WhatsAppButton";
import PendingPaymentNotice from "./PendingPaymentNotice";
import { PageLoader } from "./PageLoader";

export default function MainLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <PendingPaymentNotice />
      <div className="flex flex-1 flex-col w-full h-auto">
        <Suspense fallback={<PageLoader />}>
          <Outlet />
        </Suspense>
      </div>
      <WhatsAppButton />
      <Footer />
    </div>
  );
}
